import {
  selBusinessDataSum,
  selBusinessTypeDataCount,
  selBusinessSalesTopDataCount,
  selBusinessUpTrendDataList,
  selBusinessTypeUpTrendDataList,
  selBusinessShopLocalByParam,
}
  from "@/api/statBusiness";
export default {
  namespaced: true,
  actions: {
    // 查询 累计营业所数量
    async selBusinessDataSum(context, params) {
      const { data } = await selBusinessDataSum(params);
      return data;
    },
    // 查询 累计营业所数量
    async selBusinessTypeDataCount(context, params) {
      const { data } = await selBusinessTypeDataCount(params);
      return data;
    },
    // 查询 累计营业所数量
    async selBusinessSalesTopDataCount(context, params) {
      const { data } = await selBusinessSalesTopDataCount(params);
      return data;
    },
    // 查询 累计营业所数量
    async selBusinessUpTrendDataList(context, params) {
      const { data } = await selBusinessUpTrendDataList(params);
      return data;
    },
    // 查询 累计营业所数量
    async selBusinessTypeUpTrendDataList(context, params) {
      const { data } = await selBusinessTypeUpTrendDataList(params);
      return data;
    },
    // 查询 店铺坐标点
    async selBusinessShopLocalByParam(context, params) {
      const { data } = await selBusinessShopLocalByParam(params);
      return data;
    },

  }
}
